// import axios from 'axios';
// import moment from 'moment';
// import jwt from 'jwt-simple';
// import {ROOT_URL} from '../../config'; //SOCIAL_KEY

// import {axios} from '../common/index';
import get from 'lodash/get';
import {
    AUTH_USER, AUTH_ERROR, DEAUTH, DETECT_WARNING_MACHINE, SIGNUP, SIGNUP_ERR, INITIATE_SIGNIN,
    SET_FB_RESPONSE,
    CHANGE_PASSWORD, CHANGE_PASSWORD_ERR,
    REQUEST_FORGOT_PASSWORD, REQUEST_FORGOT_PASSWORD_ERR,
    UPDATE_FORGOT_PASSWORD, UPDATE_FORGOT_PASSWORD_ERR,
    SHOW_PDPA_POPUP, HIDE_PDPA_POPUP, PDPA_CONSENT_ERROR, PDPA_CONSENT_SUCCESS,
    VERIFICATION_EMAIL_SENT, VERIFICATION_PANEL_DISMISSED, VERIFICATION_RESEND_STATE
} from '../auth/type';
import { load, setAuthPending } from '../common';
import { GET_PROFILE } from '../profile/type';
import { getErrorCode } from '../../assets/util';
import { setActiveLanguage } from 'react-localize-redux';
import { isServer } from '../../store';
// Firebase is loaded on demand. There must be no static `firebase/auth` import
// anywhere reachable from the entry graph — `MainLayout.js:66` imports this
// module eagerly, so one static import here puts the whole 113 KB SDK back into
// the vendor chunk for every anonymous visitor. See `assets/firebase.js`.
import { loadFirebaseAuth } from '../../assets/firebase';
import { swal, close } from 'react-redux-sweetalert';

// Cookie utility functions
const getCookie = (name) => {
    if (typeof document === 'undefined') return null; // Server-side check

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
};

const hasAuthCookie = () => {
    if (typeof document === 'undefined') return false; // Server-side check

    // Check for either token or admin_token cookie
    const token = getCookie('token');
    const adminToken = getCookie('admin_token');

    return !!(token || adminToken);
};

const getAuthCookieValue = () => {
    if (typeof document === 'undefined') return null; // Server-side check

    // Return the first available auth cookie value
    const token = getCookie('token');
    const adminToken = getCookie('admin_token');

    return token || adminToken;
};

const isCookieExpired = (cookieName) => {
    if (typeof document === 'undefined') return true; // Server-side check

    const cookie = getCookie(cookieName);
    if (!cookie) return true;

    try {
        // Try to decode JWT token to check expiration
        const payload = JSON.parse(atob(cookie.split('.')[1]));
        const currentTime = Date.now() / 1000;
        return payload.exp < currentTime;
    } catch (error) {
        // If we can't decode the token, assume it's valid
        // This handles cases where the cookie might not be a JWT
        return false;
    }
};

const clearExpiredCookies = () => {
    if (typeof document === 'undefined') return; // Server-side check

    const cookies = ['token', 'admin_token'];

    cookies.forEach(cookieName => {
        if (isCookieExpired(cookieName)) {
            // Clear expired cookie by setting it to expire in the past
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            console.log(`Cleared expired cookie: ${cookieName}`);
        }
    });
};

// function tokenForId(content) {
//     const timestamp = new Date().getTime();
//     //sub: subject, iat: issued at time
//     return jwt.encode({ sub: content, iat: timestamp }, SOCIAL_KEY);
// }

/**
 * Enhanced cookie-based authentication function that only makes API calls when valid cookies exist
 * 
 * Features:
 * - Checks for authentication cookies before making API calls
 * - Validates cookie expiration using JWT payload
 * - Uses modern async/await pattern for better error handling
 * - Includes comprehensive logging for debugging
 * - Gracefully handles missing or invalid cookies
 * - Prevents unnecessary API calls when no valid authentication exists
 * 
 * @returns {Promise} Resolves when authentication check is complete
 */
export function signinWithCookiePromise() {
    return async (dispatch, getState, { axios, axNL }) => {
        try {
            // Clean up any expired cookies first
            clearExpiredCookies();

            // Check if authentication cookie exists before making API call
            if (!hasAuthCookie()) {
                return Promise.resolve();
            }

            // Check if the cookie is expired
            const token = getAuthCookieValue();
            if (token && isCookieExpired('token')) {
                return Promise.resolve();
            }

            const response = await axNL.get(`/profile`);

            // Validate response data
            if (!response.data || !response.data.profile) {
                return Promise.resolve();
            }

            // Dispatch authentication success
            dispatch({
                type: AUTH_USER,
                payload: { profile: response.data.profile }
            });

            // Dispatch profile data
            dispatch({
                type: GET_PROFILE,
                payload: response.data.profile
            });

            // Handle language settings
            const setting = response.data.setting || null;
            const langSetting = setting?.web_lang || 'th';
            dispatch(setActiveLanguage(langSetting));

            // Check PDPA consent after successful login
            const profile = response.data.profile;
            if (profile && profile.pdpa_consented === false) {
                dispatch(showPDPAPopup());
            }

            console.log('Profile fetched successfully from cookie authentication');
            return Promise.resolve();

        } catch (error) {
            console.warn('Failed to authenticate with cookie:', error);

            // Don't throw error, just resolve to prevent blocking app initialization
            // The user can still use the app without authentication
            return Promise.resolve();
        }
    };
}
export function signinWithCookie(token = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: INITIATE_SIGNIN,
            payload: null,
        })
        let params = {}
        if (token) {
            params.token = token
        }
        axios.get(`/profile`, {
            params
        })
            .then((response) => {
                dispatch({
                    type: AUTH_USER,
                    payload: { profile: response.data.profile }
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
                const setting = response.data.setting || null;
                let langSetting = setting.web_lang || 'th';
                dispatch(setActiveLanguage(langSetting));
                dispatch({
                    type: INITIATE_SIGNIN,
                    payload: true,
                })
            })
            .catch((error) => {
                dispatch({
                    type: INITIATE_SIGNIN,
                    payload: true,
                })
            })
    }
}
/**
 * Exchanges a Firebase ID token for the Beautrium profile and puts it in redux.
 *
 * AWAITABLE ON PURPOSE (item 01b QC finding MED-3). This used to be a
 * fire-and-forget `.then()` chain, which was fine while its only caller was the
 * `onIdTokenChanged` listener in `MainLayout`. It is not fine now:
 * `refreshVerificationStatus` has to know when `state.prof.profile` actually
 * carries the new `email_verified`, because the checkout gate re-submits the
 * order the moment it is told the customer is verified. Racing that against an
 * un-awaited round trip shows the customer the same gate immediately after
 * telling them they were verified — the "same message twice" failure the UX
 * spec forbids.
 *
 * It NEVER REJECTS. `MainLayout.accessTokenVerifyCall` calls it without
 * awaiting, and an unhandled rejection there would be a console error on every
 * token rotation during an outage. Failure resolves to `null` and dispatches
 * `AUTH_ERROR`, exactly as before.
 *
 * @param {string} accessToken - A Firebase ID token.
 * @returns {Function} redux-thunk resolving to the profile object, or `null` on failure.
 */
export function accessTokenVerify(accessToken) {
    return async (dispatch, getState, { axios }) => {
        try {
            const response = await axios.post(`/v3/auth/accesstoken/verify`, { token: accessToken });

            localStorage.setItem("token", response.data.token);
            localStorage.setItem("profile", JSON.stringify(response.data.profile));

            dispatch({ type: AUTH_USER, payload: response.data });
            dispatch({ type: DETECT_WARNING_MACHINE, payload: false });
            dispatch({ type: GET_PROFILE, payload: response.data.profile });

            // Check PDPA consent after successful login
            const profile = response.data.profile;
            if (profile && profile.pdpa_consented === false) {
                dispatch(showPDPAPopup());
            }
            return profile || null;
        } catch (error) {
            dispatch({
                type: AUTH_ERROR,
                payload: error.response?.data?.message || "Some error has occured. Please try again later."
            });

            if (error.response?.data?.suspicious) {
                dispatch({
                    type: DETECT_WARNING_MACHINE,
                    payload: error.response.data.suspicious
                });
            }
            return null;
        }
    }
}

export function fbSignin(accessToken, fbUserID) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: AUTH_ERROR,
            payload: ""
        });

        axios.post(`/auth/facebook`, { //signin_fb
            // "username": signedRequest, 
            // "password": token
            access_token: accessToken
        })
            .then((response) => {
                // localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                localStorage.setItem("fb_auth", fbUserID);
                // localStorage.setItem("token_keep", response.data.token);
                // localStorage.setItem("profile_keep", JSON.stringify(response.data.profile));
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
            })
            .catch((error) => {
                dispatch({
                    type: AUTH_ERROR,
                    payload: error.response?.data?.message || "Some error has occured. Please try again later."
                });
            });
    }
}

// `signup()` (legacy POST /signup) was DELETED in item 01 together with the
// backend route, `views/Signup.js` and the `/signup` client route. Use
// `firebaseSignup` below: the storefront's only live registration path.

/**
 * Register a Firebase-authenticated user with the backend.
 *
 * @param {object} params
 * @param {string} params.accessToken - Firebase ID token, sent as the Bearer credential.
 * @param {string} params.first_name - Given name.
 * @param {string} [params.last_name] - Family name.
 * @param {boolean} [params.email_consent] - Marketing consent flag.
 * @param {string|null} [params.recaptchaToken] - Signup bot-protection challenge
 *        token, sent as `recaptcha_token`. `null` when no site key is configured;
 *        the backend guard is inert by default so an absent token changes nothing.
 * @returns {Function} redux-thunk dispatching `AUTH_USER`/`GET_PROFILE`/`SIGNUP`,
 *          or `SIGNUP_ERR` with `{ error: { code, message } }` on failure.
 */
export function signUpWithFirebase({ accessToken, first_name, last_name, email_consent, recaptchaToken = null, ...rest }) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SIGNUP,
            payload: null,
        });
        dispatch({
            type: SIGNUP_ERR,
            payload: null
        })
        axios.post(`/v3/auth/signup`, {
            first_name, last_name, email_consent, recaptcha_token: recaptchaToken, ...rest
        }, {
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            }
        })
            .then((response) => {
                dispatch({
                    type: AUTH_USER,
                    payload: response.data
                });
                dispatch({
                    type: DETECT_WARNING_MACHINE,
                    payload: false
                });
                dispatch({
                    type: GET_PROFILE,
                    payload: response.data.profile
                });
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("profile", JSON.stringify(response.data.profile));
                dispatch({
                    type: SIGNUP,
                    payload: true,
                });
            })
            .catch((error) => {
                dispatch({
                    type: SIGNUP_ERR,
                    payload: { error: { code: get(error, "response.data.code", "CODE_UNAVAILABLE"), message: get(error, "response.data.message", 'Something went wrong.') } }, // error.response ? (error.response.data ? error.response.data.code : "ERROR.CODE_UNAVAILABLE") : "ERROR.CODE_UNAVAILABLE",
                });
                dispatch({
                    type: SIGNUP,
                    payload: false,
                });
            })
    }
}

// `signupWithProfile()` (the second legacy POST /signup caller) was DELETED in
// item 01. Its only consumer was `components/event/july_payday/the1bill_form.js`,
// which never invoked it, on a page whose route has been commented out since the
// 2020 campaign (`src/index.js`).

/**
 * Sign the user out of Firebase and of the backend, then clear the local session.
 *
 * Sign-out deliberately **fails open**: whatever goes wrong remotely — the
 * Firebase chunk failing to download, `signOut` rejecting, the backend call
 * failing — the local session is still cleared and the user sees themselves
 * signed out. Leaving someone apparently signed in because a network request
 * failed is the worse outcome on a shared device. The previous implementation
 * had no rejection handler on `signOut(auth)` at all, so a Firebase failure
 * silently left the user signed in and nothing further happened.
 *
 * @returns {Function} redux-thunk that dispatches `DEAUTH`.
 */
export function signout() {
    return async (dispatch, getState, { axios }) => {
        try {
            const { auth, authApi } = await loadFirebaseAuth();
            await authApi.signOut(auth);
        } catch (error) {
            // Not swallowed: the recovery is "clear the session anyway", below.
            // The Firebase-side session may survive in IndexedDB; the app's own
            // token is what gates access, and that is cleared.
            console.warn('Firebase sign-out failed; clearing the local session anyway.', get(error, 'code', get(error, 'message', 'unknown')));
        }

        try {
            await axios.post(`/v3/auth/signout`);
        } catch (error) {
            console.warn('Backend sign-out failed; clearing the local session anyway.', get(error, 'response.status', get(error, 'message', 'unknown')));
        }

        localStorage.clear();
        dispatch({
            type: DEAUTH
        });
    }
}

export function setFbResponse(fbResponse) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SET_FB_RESPONSE,
            payload: fbResponse
        })
    }
}

/**
 * Change the signed-in user's Firebase password.
 *
 * If the Firebase chunk cannot be loaded, `loadFirebaseAuth` throws
 * `FirebaseUnavailableError` and it lands in the same `CHANGE_PASSWORD_ERR`
 * branch as a real Firebase rejection, so `PasswordForm.js:19-26` shows its
 * "Update Password Failed" dialog with a reason instead of hanging.
 *
 * @param {string} newPassword - The new password.
 * @returns {Function} redux-thunk dispatching `CHANGE_PASSWORD` /
 *   `CHANGE_PASSWORD_ERR`.
 */
export function changePassword(newPassword) {
    return async (dispatch) => {
        dispatch({
            type: CHANGE_PASSWORD,
            payload: null
        });
        try {
            const { auth, authApi } = await loadFirebaseAuth();
            await authApi.updatePassword(auth.currentUser, newPassword);
            dispatch({
                type: CHANGE_PASSWORD,
                payload: true
            });
        } catch (error) {
            // Deviation from the previous payload shape: this dispatched the
            // Error *object*, which `PasswordForm.js:23` passes straight to
            // swal's `text`, rendering "[object Object]". A message string is
            // the only shape that consumer can display.
            dispatch({
                type: CHANGE_PASSWORD_ERR,
                payload: get(error, 'message', 'ERROR.CODE_UNAVAILABLE')
            });
        }
        // axios.post(`/changePassword`, {
        //     oldPassword, newPassword
        // }, {
        //     headers: {
        //         authorization: localStorage.getItem('token')
        //     }
        // })
        //     .then((response) => {
        //         dispatch({
        //             type: CHANGE_PASSWORD,
        //             payload: true
        //         });
        //     })
        //     .catch((error) => {
        //         const err_code = getErrorCode(error);
        //         dispatch({
        //             type: CHANGE_PASSWORD_ERR,
        //             payload: err_code
        //         });
        //     })
    }
}

export function forgotPasswordRequest(email) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: REQUEST_FORGOT_PASSWORD,
            payload: null
        });
        axios.post(`/forgot_password`, {
            email
        })
            .then((response) => {
                dispatch({
                    type: REQUEST_FORGOT_PASSWORD,
                    payload: true
                });
            })
            .catch((error) => {
                const err_code = getErrorCode(error);
                dispatch({
                    type: REQUEST_FORGOT_PASSWORD_ERR,
                    payload: err_code
                });
            })
    }
}
export function updateForgotPassword(token, password) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: UPDATE_FORGOT_PASSWORD,
            payload: null
        });
        axios.post(`/update_forgot_password`, {
            token, password
        })
            .then((response) => {
                dispatch({
                    type: UPDATE_FORGOT_PASSWORD,
                    payload: true
                });
            })
            .catch((error) => {
                const err_code = getErrorCode(error);
                dispatch({
                    type: UPDATE_FORGOT_PASSWORD_ERR,
                    payload: err_code
                });
            })
    }
}
/**
 * Sign in with email and password via Firebase.
 *
 * A `FirebaseUnavailableError` from `loadFirebaseAuth` is dispatched as
 * `AUTH_ERROR` exactly like a wrong password would be. Its `code` is
 * `auth/module-load-failed`, and `LoginForm.js:94` / `SigninForm.js:129`
 * render `ERROR.AUTH.<code>`, which now exists in `lang/err_lang.js` — so the
 * user is told to check their connection instead of watching a spinner that
 * never clears. `load(false)` is dispatched on every path.
 *
 * @param {string} username - The account email.
 * @param {string} password - The account password.
 * @returns {Function} redux-thunk dispatching `AUTH_ERROR` on failure.
 */
export function firebaseSigninUsernameAndPassword(username, password) {
    return async (dispatch, getState, { axios }) => {
        dispatch(load(true));
        dispatch(setAuthPending('email'));
        try {
            localStorage.removeItem('token');
            const { auth, authApi } = await loadFirebaseAuth();
            await authApi.setPersistence(auth, authApi.browserLocalPersistence);
            const userCredential = await authApi.signInWithEmailAndPassword(auth, username, password);
            // Automatically refresh the access token when it's about to expire
            authApi.onIdTokenChanged(auth, (user) => {
                if (user) {
                    // User is signed in, and the token has been refreshed
                    const accessToken = user.accessToken;
                    localStorage.setItem("accessToken", accessToken);
                    dispatch(accessTokenVerify(accessToken));
                }
            });
            dispatch(load(false));
            const user = userCredential.user;
            dispatch(accessTokenVerify(user.accessToken));
        } catch (error) {
            dispatch(load(false));
            dispatch({
                type: 'AUTH_ERROR', //auth error,
                payload: error,
            });
        } finally {
            // `finally` rather than a clear beside each `load(false)`: a missed
            // path here leaves a button spinning forever, which is worse than
            // no spinner at all. See design.md D3/D4.
            dispatch(setAuthPending(null));
        }
    }
}
/**
 * Sign in through a social provider popup (Facebook, Google or Apple).
 *
 * Everything now sits inside the `try`. Previously the provider construction and
 * `setPersistence` ran *outside* it, so a failure there rejected the thunk with
 * the global spinner still up and nothing shown to the user. With Firebase
 * loaded lazily that window is exactly where a chunk failure lands, so the
 * whole body is guarded and every path ends in a dialog plus `load(false)`.
 *
 * @param {'facebook'|'google'|'apple'} type - Which provider to use.
 * @returns {Function} redux-thunk; shows a swal dialog on any failure.
 */
export function firebaseSigninRedirect(type) {
    return async (dispatch, getState, { axios }) => {
        dispatch(load(true));
        dispatch(setAuthPending(type));
        try {
            localStorage.removeItem('token');
            const { auth, authApi } = await loadFirebaseAuth();
            let provider;
            switch (type) {
                case 'facebook':
                    provider = new authApi.FacebookAuthProvider(); break;
                case 'google':
                    provider = new authApi.GoogleAuthProvider(); break;
                case 'apple':
                    provider = new authApi.OAuthProvider('apple.com'); break;
                default:
                    break;
            }
            if (!provider) {
                // Previously `throw Error({...})`, which produces the message
                // "[object Object]"; it also escaped the try/catch entirely.
                throw new Error(`Unknown sign-in provider: ${type}`);
            }
            provider.addScope('email');
            await authApi.setPersistence(auth, authApi.browserLocalPersistence);
            // return signInWithRedirect(auth, provider);
            let userCred = await authApi.signInWithPopup(auth, provider);
            authApi.onIdTokenChanged(auth, (user) => {
                if (user) {
                    // User is signed in, and the token has been refreshed
                    const accessToken = user.accessToken;
                    localStorage.setItem("accessToken", accessToken);
                    dispatch(accessTokenVerify(accessToken));
                }
            });
            dispatch(getCredFromPopup(userCred));
        } catch (error) {
            dispatch(load(false));
            let text = get(error, "message", `เกิดปัญหาขัดข้อง กรุณาลองใหม่อีกครั้งค่ะ ${error}`);
            if (error.code === 'auth/account-exists-with-different-credential') {
                text = 'พบอีเมลล์เดิมของลูกค้าสมัครโดยใช้วิธีอ่ื่น กรุณาใช้วิธีเดิมในการเข้าสู่ระบบค่ะ';
            }
            dispatch(swal({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: text,
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: dispatch(close()),
            }));
        } finally {
            // Covers cancel too: closing the Google/Facebook window rejects
            // `signInWithPopup` with `auth/popup-closed-by-user`, which lands in
            // the catch above and then here, so the button comes back.
            //
            // On success the global `load(false)` is dispatched slightly later,
            // inside `getCredFromPopup`; clearing the button state here instead
            // is deliberate - the popup has already closed by then.
            dispatch(setAuthPending(null));
        }
    }
}
/**
 * Create a Firebase account and register it with the backend.
 *
 * A chunk-load failure surfaces as `SIGNUP_ERR` with `code`
 * `auth/module-load-failed`, i.e. the same path as `auth/email-already-in-use`,
 * so the sign-up form reports it rather than leaving the spinner up.
 *
 * @param {object} params
 * @param {string} params.email - Account email.
 * @param {string} params.password - Chosen password.
 * @param {string} params.first_name - Given name, used for `displayName`.
 * @param {string} [params.last_name] - Family name.
 * @param {boolean} [params.email_consent] - Marketing consent flag.
 * @param {string|null} [params.recaptchaToken] - Signup bot-protection challenge
 *        token, threaded through to `signUpWithFirebase` unchanged.
 * @returns {Function} redux-thunk dispatching `SIGNUP_ERR` on failure.
 */
export function firebaseSignup({ email, password, first_name, last_name, email_consent, recaptchaToken = null, ...rest }) {
    return async (dispatch, getState, { axios }) => {
        try {
            dispatch(load(true));
            dispatch(setAuthPending('email'));
            const { auth, authApi } = await loadFirebaseAuth();
            const userCredential = await authApi.createUserWithEmailAndPassword(auth, email, password);
            const accessToken = userCredential.user.accessToken;
            const displayName = first_name.trim() + ((last_name && last_name.trim() !== '' ? ' ' + last_name : ''));
            await authApi.updateProfile(userCredential.user, { displayName: displayName });

            // PREPARED, NOT ENFORCED. Firebase owns email verification end to end:
            // it sends the mail and publishes the outcome as the `email_verified`
            // claim in the ID token the backend already verifies. Sending it now
            // means accounts accumulate verified status BEFORE anything is gated
            // on it — the backend's EMAIL_VERIFICATION_MODE stays `off` until the
            // client turns it on, and must not be promoted until the Flutter app
            // ships the same call (a store release; see console-runbook.md).
            //
            // Failure here must never fail the registration: the account exists
            // and is usable, and the user can be re-sent the mail later.
            try {
                await authApi.sendEmailVerification(userCredential.user);
                // Item 01b: tell the UI, so the customer is shown WHERE the link
                // went instead of being silently signed in and left to discover
                // an unexplained mail later. Non-blocking — the account works.
                dispatch(verificationEmailSent({ email }));
            } catch (verificationError) {
                console.warn('Could not send the verification email; registration continues.', verificationError.code);
            }

            dispatch(load(false));
            dispatch(signUpWithFirebase({ accessToken, first_name, last_name, email_consent, recaptchaToken }));
        } catch (error) {
            dispatch(load(false));
            dispatch({
                type: SIGNUP_ERR,
                payload: error,
            });
        } finally {
            // Cleared before `signUpWithFirebase` resolves, matching the timing
            // of the existing `load(false)` on the success path above.
            dispatch(setAuthPending(null));
        }
    }
}

export function getCredFromPopup(result) {
    return async (dispatch, getState, { axios }) => {
        try {
            if (!result) {
                dispatch(load(false));
                return;
            }
            const user = result.user;
            const accessToken = user.accessToken;

            dispatch(load(false));
            dispatch(accessTokenVerify(accessToken));
        } catch (error) {
            dispatch(load(false));
            dispatch(swal({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: get(error, "message", `เกิดปัญหาขัดข้อง กรุณาลองใหม่อีกครั้งค่ะ ${error}`),
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: dispatch(close()),
            }));
        }
    }
}

export function getRedirectFromProvider(result) {
    return async (dispatch, getState, { axios }) => {
        try {
            if (!result) {
                dispatch(load(false));
                return;
            }
            const user = result.user;
            const accessToken = user.accessToken;
            dispatch(load(false));
            dispatch(accessTokenVerify(accessToken));
        } catch (error) {
            dispatch(load(false));
            dispatch(swal({
                title: 'เข้าสู่ระบบไม่สำเร็จ',
                text: get(error, "message", `เกิดปัญหาขัดข้อง กรุณาลองใหม่อีกครั้งค่ะ ${error}`),
                type: 'error',
                customClass: 'bt-dialog-box',
                onConfirm: dispatch(close()),
            }));
        }
    }
}

// PDPA Consent Actions
export function showPDPAPopup() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SHOW_PDPA_POPUP,
            payload: true
        });
    }
}

export function hidePDPAPopup() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: HIDE_PDPA_POPUP,
            payload: false
        });
    }
}

export function submitPDPAConsent() {
    return (dispatch, getState, { axios }) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: PDPA_CONSENT_SUCCESS,
                payload: null
            });

            axios.post('/v3/users/me/pdpa/consent')
                .then((response) => {
                    dispatch({
                        type: PDPA_CONSENT_SUCCESS,
                        payload: true
                    });
                    dispatch(hidePDPAPopup());
                    resolve(response);
                })
                .catch((error) => {
                    dispatch({
                        type: PDPA_CONSENT_ERROR,
                        payload: get(error, "response.data.message", "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
                    });
                    reject(error);
                });
        });
    }
}

export function getPDPAPolicy() {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise((resolve, reject) => {
            axStrapi.get('/policy-page')
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}
/* ------------------------------------------------------------------ *
 * Item 01b — the email-verification UX.
 *
 * THE ONE RULE THAT KEEPS THESE FROM FIGHTING EACH OTHER: the client NEVER
 * decides verification status. It never renders a gate or a banner from
 * `auth.currentUser.emailVerified`. It renders from `state.prof.profile
 * .email_verified`, which came from the backend. The client's only job is to
 * force Firebase to re-issue the token and then re-ask the server. There is
 * exactly one source of truth in this UI and it is the server's answer.
 * ------------------------------------------------------------------ */

/**
 * Records that a verification mail has just gone out, so the "check your email"
 * panel can name the address it went to.
 *
 * @param {object} params
 * @param {string} params.email - The address Firebase sent the link to.
 * @returns {{type: string, payload: {email: string}}} Plain action.
 */
export function verificationEmailSent({ email }) {
    return { type: VERIFICATION_EMAIL_SENT, payload: { email } };
}

/**
 * Dismisses the post-signup panel or the persistent banner for this session.
 *
 * Session-scoped by design: it is stored in redux and not persisted, so the
 * banner returns on the customer's next visit. An unverified address is a
 * standing problem, not a one-off notice.
 *
 * @returns {{type: string}} Plain action.
 */
export function dismissVerificationPanel() {
    return { type: VERIFICATION_PANEL_DISMISSED };
}

/**
 * Forces Firebase to re-issue an ID token, then re-asks the backend who this
 * user is — and only resolves once the backend has answered.
 *
 * WHY IT EXISTS. `email_verified` is a claim baked into the ID token, and
 * Firebase only reissues that token about hourly. A customer who clicks the
 * verification link and comes back keeps presenting `email_verified: false`,
 * which reads as "the site is broken". `reload()` refetches the account record
 * and `getIdToken(true)` forces a new token carrying the new claim.
 *
 * WHY IT AWAITS `accessTokenVerify` DIRECTLY (QC finding MED-3). Forcing a token
 * ALSO fires `onIdTokenChanged` (`MainLayout.js:527`), whose handler calls
 * `accessTokenVerify` without awaiting it. Relying on that listener would make
 * this resolve before `state.prof.profile` had been rewritten, and the checkout
 * gate re-submits the order on `true`. So the refresh is awaited here, on the
 * caller's own path, and the answer this resolves with is the SERVER's — not
 * Firebase's local `emailVerified`, which is deliberately never read.
 *
 * It never rejects: a network failure or `auth/user-token-expired` resolves
 * `false` and dispatches the code through the existing `ERROR.AUTH.<code>`
 * path. A silent success would look exactly like "verified but still blocked".
 *
 * @returns {Function} redux-thunk resolving `true` only when the backend now
 *          reports this account as verified.
 */
export function refreshVerificationStatus() {
    return async (dispatch, getState) => {
        try {
            const { auth, authApi } = await loadFirebaseAuth();
            const user = auth.currentUser;
            if (!user) return false;

            await authApi.reload(user);
            const token = await user.getIdToken(true);

            const profile = await dispatch(accessTokenVerify(token));
            return Boolean(profile && profile.email_verified === true);
        } catch (error) {
            // Firebase raises `auth/*` codes, which `ERROR.AUTH.<code>` already
            // translates; `getErrorCode` is for axios errors and would flatten
            // them all to CODE_UNAVAILABLE.
            dispatch({
                type: AUTH_ERROR,
                payload: error.code || error.message,
            });
            return false;
        }
    };
}

/**
 * Asks the backend for permission to send another verification mail, and sends
 * it through Firebase when permission is granted.
 *
 * TWO ENFORCEMENT POINTS, AND THAT IS DELIBERATE. The countdown the customer
 * sees is rendered in the component, because a button that goes dead with no
 * explanation reads as a broken site. But a component-side cooldown is
 * advisory — a page reload clears it — so the authority is
 * `POST /v3/auth/verification/resend-slot`, which owns the 60 s -> doubling ->
 * 5-minute ladder and the five-per-hour cap. Root CLAUDE.md rule 7.
 *
 * The backend sends no mail; Firebase does (item 01 deviation D-I8). This
 * degrades on purpose: if the slot endpoint is unreachable — an older backend,
 * a blip — the mail is still sent and only the client-side cooldown applies.
 * Refusing to help a customer who cannot log in because our own quota service
 * is down would be the wrong trade.
 *
 * @returns {Function} redux-thunk resolving
 *          `{ sent: boolean, cooldownSeconds: number, errorCode: (string|null) }`.
 */
export function resendVerificationEmail() {
    return async (dispatch, getState, { axNL }) => {
        dispatch({ type: VERIFICATION_RESEND_STATE, payload: { pending: true, errorCode: null } });

        let cooldownSeconds = 60;
        try {
            const { data } = await axNL.post('/v3/auth/verification/resend-slot');
            cooldownSeconds = get(data, 'cooldown_seconds', 60);
        } catch (error) {
            const status = get(error, 'response.status', null);
            if (status === 429 || status === 403) {
                const payload = {
                    pending: false,
                    errorCode: get(error, 'response.data.code', 'VERIFICATION_RESEND_THROTTLED'),
                    cooldownSeconds: get(error, 'response.data.retry_after_seconds', 60),
                };
                dispatch({ type: VERIFICATION_RESEND_STATE, payload });
                return { sent: false, cooldownSeconds: payload.cooldownSeconds, errorCode: payload.errorCode };
            }
            // Any other failure (offline, 404 on an older backend) falls through
            // and still sends: see the degradation note above.
            console.warn('Resend slot check unavailable; sending anyway.', status);
        }

        try {
            const { auth, authApi } = await loadFirebaseAuth();
            const user = auth.currentUser;
            if (!user) {
                const payload = { pending: false, errorCode: 'auth/user-not-found', cooldownSeconds };
                dispatch({ type: VERIFICATION_RESEND_STATE, payload });
                return { sent: false, cooldownSeconds, errorCode: 'auth/user-not-found' };
            }

            await authApi.sendEmailVerification(user);
            dispatch({ type: VERIFICATION_RESEND_STATE, payload: { pending: false, errorCode: null, cooldownSeconds } });
            return { sent: true, cooldownSeconds, errorCode: null };
        } catch (error) {
            const errorCode = error.code || 'CODE_UNAVAILABLE';
            dispatch({ type: VERIFICATION_RESEND_STATE, payload: { pending: false, errorCode, cooldownSeconds } });
            return { sent: false, cooldownSeconds, errorCode };
        }
    };
}
